import gql from 'graphql-tag'

export const USER_FIELDS = gql`
    fragment UserFields on User {
        avatarFileId
        primaryEmail
        id
        name
    }
`

export const COURSE_FIELDS = gql`
    fragment CourseFields on Course {
        allowAttestation
        allowSelfAttestation
        attestationRequiresCertificate
        canCreateAttestedCompletion
        canCreateInstructedCompletion
        canCreateSelfAttestedCompletion
        canCreateSelfGuidedCompletion
        code
        completionValidityPeriodDays
        createdAt
        id
        includeInPsi
        instructorFormActiveRevision
        instructorFormResource
        isArchived
        isDraft
        isRequiredForCheckIn
        responsesAreCompanyWide
        selfGuidedFormActiveRevision
        selfGuidedFormResource
        suggestToAllUsers
        updatedAt
        name
        description
    }
`
